import { format } from "date-fns";
import { currency_symbol } from "./modules/common/CurrencySymbol/currencySymbol";
import { isEmpty } from "lodash";

// check for empty object
export function isDataEmpty(obj) {
  if (typeof obj == "object") {
    return Object.keys(obj).length === 0;
  } else if (typeof obj == "string") {
    if (obj != null) {
      return true;
    }
    return false;
  }
}

// date format function
export function dateDDMM(string) {
  let date = format(new Date(string), "MMM d");
  return date;
}

// return date range format
export function dateRangeFormat(string1, string2) {
  let date = "";
  if (new Date(string1).getMonth() === new Date(string2).getMonth()) {
    date =
      format(new Date(string1), "MMM d") + "-" + format(new Date(string2), "d");
  } else {
    date =
      format(new Date(string1), "MMM d") +
      "-" +
      format(new Date(string2), "MMM d");
  }
  return date;
}

export function dateFormatwithDay(date) {
  let day = new Date(date);
  return format(day, "EEE, d MMM");
}

// guest info function
export function guestInfo(adults, child) {
  let newAdult = "";
  let newChild = "";
  if (adults > 1) {
    newAdult = adults + " adults";
  } else if (adults === 1) {
    newAdult = adults + " adult";
  } else {
    newAdult = "";
  }

  if (child > 1) {
    newChild = child + " children";
  } else if (child === 1) {
    newChild = child + " child";
  } else {
    newChild = "";
  }

  if (adults === 0 && child) {
    return newChild;
  } else if (adults && child === 0) {
    return newAdult;
  } else if (adults && child) {
    return newAdult + ", " + newChild;
  }
}

// function to check for null and undefined
export function checkUndefined(obj) {
  return obj === undefined;
}

// check nukk
export function checkNull(obj) {
  return obj === null;
}

// booking status wrapper
export const bookingStatusWrapper = {
  BOOKING_CONFIRMED: "Booking Confirmed",
};

export function days_between(date1, date2) {
  // The number of milliseconds in one day
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Calculate the difference in milliseconds
  const differenceMs = Math.abs(new Date(date1) - new Date(date2));

  // Convert back to days and return
  return Math.round(differenceMs / ONE_DAY);
}

// Get dates between two dates
Date.prototype.addDays = function (days) {
  var dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
};

export function getDates(startDate, stopDate) {
  var dateArray = new Array();
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(currentDate);
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

export function removeDuplicates(arr) {
  let unique = arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
  return unique;
}

export function removeDuplicatesActivity(arr, key) {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
}

export function onlySpaces(str) {
  return str.trim().length === 0;
}

export function getImageUrlFromName(name) {
  let baseUrl = "https://d1tf573zhz3zzy.cloudfront.net/data/content/icons/";
  if (name != undefined) {
    return baseUrl + name + ".png";
  }
  return null;
}

export const ItemType = {
  destination: "DESTINATION",
  attraction: "ATTRACTION",
  activity: "ACTIVITY",
  trip: "TRIP",
  country: "COUNTRY",
  homeStay: "VACATION_HOME",
  hotel: "HOTEL",
  video: "VIDEO",
};

// show more show less
// let showHideContent = {
//   name: "name",
//   index: 0,
//   subindex : 0
// }

let showHideContentList = [];
const showHideContentName = {
  stop: "stop",
  hotel: "hotel",
};

let showHideFlag = false;

function contentStatus(name, index, subindex) {
  console.log("contentStatus " + name + " : ", index, " : ", subindex);

  for (let i = 0; i < showHideContentList.length; i++) {
    let showHideContent = showHideContentList[i];
    if (
      showHideContent.name == name &&
      showHideContent.index == index &&
      showHideContent.subindex == subindex
    ) {
      console.log("contentStatus " + true);
      showHideFlag = true;
      return showHideFlag;
      break;
    }
  }
  console.log("contentStatus " + false);
  showHideFlag = false;
  return showHideFlag;
}

function updateContentStatus(name, index, subindex) {
  console.log("contentStatus " + name + " : ", index, " : ", subindex);

  let oldIndex = -1;

  for (let i = 0; i < showHideContentList.length; i++) {
    let showHideContent = showHideContentList[i];
    if (
      showHideContent.name == name &&
      showHideContent.index == index &&
      showHideContent.subindex == subindex
    ) {
      oldIndex = i;
      break;
    }
  }
  if (oldIndex >= 0) {
    console.log("contentStatus oldIndex : " + oldIndex);

    showHideContentList.splice(oldIndex, 1);
  } else {
    let showHideContent = {
      name: name,
      index: index,
      subindex: subindex,
    };

    console.log("showHideContent : ");
    console.log(showHideContent);
    showHideContentList.push(showHideContent);
  }
}

export function capitalizeFirstLetter(string) {
  let lower = string.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export let ChipTitle = {
  HOTEL: "Stay",
  ATTRACTION: "Stop",
  ACTIVITY: "Stop",
};

export function getNoteUrlFromName(name) {
  let baseUrl =
    "https://d1tf573zhz3zzy.cloudfront.net/trip_portal/notes/general_notes/";
  if (name != undefined) {
    return baseUrl + name + ".png";
  }
  return null;
}

export function toTitleCase(str) {
  str = str.toLowerCase().split(" ");
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(" ");
}

export function getCurrencySymbol(currency_code, fallback_currency) {
  // console.log('currency_code:::', currency_code)

  if (currency_code === null || isEmpty(currency_code)) {
    return "";
  }

  let symbol = currency_symbol[currency_code];
  // console.log('currency_symbol:::', currency_symbol)
  if (!isEmpty(symbol)) {
    return symbol;
  } else {
    return currency_code;
  }
}
